import React, {lazy, Suspense, useEffect} from "react";
import LandinPage from "../LandingPage/LandinPage";
import QuickMenu from "../quickMenu/quickMenu";
import Loading from "../LoadingAnimation/Loading";
import {useDispatch} from "react-redux";
import {Helmet} from "react-helmet";
const FAQ = lazy(() => import("../FAQ/FAQ"));
const CallToAction = lazy(() => import("../PriicingTable/AppoinmentCall"));

export default function () {
    const dispatch = useDispatch();
     useEffect(() => {
         const user = JSON.parse(localStorage.getItem("user"));
         const jwt = JSON.parse(localStorage.getItem("token"));
         if (user) {
            dispatch({ type: "LOG_IN", payload: true });
            dispatch({ type: "JWT", payload: jwt });
            dispatch({ type: "USER", payload: user });
        }
    }, [dispatch]);
  return (
    <>
        <Helmet>
            <title>AtUrServices</title>
            <meta name="description" content="Aturservices is your personal home
                improvement consultant and a trusted, knowledgeable resource
                that is part of a leading national service franchise" />
        </Helmet>
      <LandinPage />
      <QuickMenu />
      <Suspense fallback={<Loading />}>
          <CallToAction/>
        <FAQ />
      </Suspense>

    </>
  );
}
